(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.utilityBar = document.querySelector('.utility-bar');
      this.headerInnerContent = document.querySelector('header');
      this.headerBounds = {};
      if (this.header && this.utilityBar) {
        this.setHeaderHeightAndAnnoucementBar();
      } else if (this.header) {
        this.setHeaderHeight();
      }
      this.setHeaderInnercontentWidth();
      window.addEventListener('resize', this.setHeaderInnercontentWidth.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight?.bind(this));
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.header) {
        const headerDistance = this.header.getBoundingClientRect().top;
        document.documentElement.style.setProperty('--top', `${headerDistance}px`);
      }
    }
    setHeaderInnercontentWidth() {
      if (!this.headerInnerContent) return;
      const width = this.headerInnerContent.offsetWidth;
      document.documentElement.style.setProperty('--desktop-header-content-width', `${width}px`);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    setHeaderHeightAndAnnoucementBar() {
      if (!this.header) return;
      const util = this.utilityBar ? this.utilityBar.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight + util}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      if (!this.header) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      throttle(() => {
        const headerDistance = this.header.getBoundingClientRect().top;
        document.documentElement.style.setProperty('--top', `${headerDistance}px`);
      }, 200)();
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setHeaderHeight();
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.setHeaderHeight();
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 200);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.setHeaderHeightAndAnnoucementBar();
        requestAnimationFrame(this.reset.bind(this));
      } else {
        this.setHeaderHeight();
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.documentElement.classList.add('header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.classList.remove('header-hidden');
    }
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-promo-highlight"] && !Shopify.designMode) return;
  try {
    
/* Intentionally left empty: main logic in inline <script> for single-file portability */

  } catch(e) { console.error(e); }
})();
})();
